/**
 * Перезапуск мини-аппы целиком.
 *
 * Живёт в платформенном слое, а не в компоненте, по правилу 6: `window` в разметке не бывает
 * (docs/telegram.md §1). Никакого телеграмного API для перезапуска нет — и в Telegram, и в
 * браузере мини-аппа это обычный вебвью, поэтому перезагрузка страницы и есть перезапуск.
 *
 * Отдельно от `reset` у `ErrorBoundary`, и разница существенная. `reset` только сбрасывает
 * состояние самого бордера и просит React перерисовать то же поддерево с теми же данными:
 * помогает, если сбой был случайным, и не помогает никогда, если упало из-за самих данных.
 * Перезагрузка поднимает приложение с нуля — заново авторизация, заново запросы, заново
 * состояние.
 */
export const reloadApp = (): void => {
  window.location.reload()
}
